import { useEffect } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import {
  isPausedAtom, isMutedAtom, genesisBlockAtom,
  lightningModeAtom, nodeMapActiveAtom, ENABLE_NODE_GLOBE,
  searchedBlockAtom, welcomeMessageVisibleAtom,
  timechainViewAtom,
} from '../state/atoms';
import { setMuted } from '../utils/audio';
import { toggleWelcomeWithDebounce } from '../components/EditableWelcome';

export const useKeyboardShortcuts = () => {
  const [, setIsPaused] = useRecoilState(isPausedAtom);
  const [, setIsMuted] = useRecoilState(isMutedAtom);
  const setGenesis = useSetRecoilState(genesisBlockAtom);
  const setSearchedBlock = useSetRecoilState(searchedBlockAtom);
  const setLightning = useSetRecoilState(lightningModeAtom);
  const setNodeMap = useSetRecoilState(nodeMapActiveAtom);
  const setWelcomeVisible = useSetRecoilState(welcomeMessageVisibleAtom);
  const [timechain, setTimechain] = useRecoilState(timechainViewAtom);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
      if (e.ctrlKey || e.metaKey || e.altKey) return;

      switch (e.code) {
        case 'KeyP':
          e.preventDefault();
          setIsPaused(p => !p);
          break;
        case 'KeyM':
          e.preventDefault();
          setIsMuted(m => {
            setMuted(!m);
            return !m;
          });
          break;
        case 'KeyG':
          e.preventDefault();
          setSearchedBlock(null);
          setGenesis(g => !g);
          break;
        case 'KeyL':
          e.preventDefault();
          setLightning(l => !l);
          break;
        case 'KeyN':
          if (!ENABLE_NODE_GLOBE) break;
          e.preventDefault();
          setTimechain(false);
          setNodeMap(n => !n);
          break;
        case 'KeyW':
          e.preventDefault();
          setWelcomeVisible(v => toggleWelcomeWithDebounce(v));
          break;
        case 'KeyT':
          e.preventDefault();
          if (!timechain) setLightning(true);
          setTimechain(t => !t);
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [setIsPaused, setIsMuted, setGenesis, setLightning, setNodeMap, setSearchedBlock, setWelcomeVisible, setTimechain, timechain]);
};
